/**
 * Gift Aid app_fee constants — the platform's % cut on Gift Aid donations,
 * applied as the GoCardless `app_fee` on payment creation.
 *
 * Lives in its own module (rather than inside `billing-requests.ts`) so
 * client-side code — the donate form's "cover the fees" calculator —
 * can read these without dragging the GoCardless SDK (Node-only deps
 * like `dns`) into the browser bundle.
 */

export const GIFT_AID_FEE_RATE = 0.0125; // 1.25%
export const GIFT_AID_FEE_CAP_PENCE = 200_000; // £2,000 base cap → max £25 fee

/**
 * Donations dated before this date are permanently excluded from the
 * claim-time platform fee basis (see lib/billing/claim-fee.ts) — the
 * grandfathering line for the claim-time fee terms (ToS §4.4).
 *
 * 2026-09-20: the day the claim-time fee terms went live. No charity was
 * processing payments or submitting claims at that point, so no ToS §15
 * change notice was needed and nothing is grandfathered in practice. If
 * the fee terms ever change again for live charities, the new line is
 * "notice emailed + 30 days" — set it here before flipping anything
 * (docs/MAINTENANCE.md → "Platform fee collection").
 */
export const FEE_EFFECTIVE_DATE = new Date('2026-09-20T00:00:00Z');
